import { Toolbar, SaveButton } from 'react-admin';

export const GenericToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="Enregistrer"
            redirect={false}
            submitOnEnter={false}
        />
        <SaveButton
            label="Enregistrer et quitter"
            redirect="list"
            submitOnEnter={false}
            variant="text"
        />
    </Toolbar>
);